import {Injectable} from '@angular/core';
import {Headers} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {ConfigService} from '../config/config.service';
import {httpExtensionService} from '../shared/services/httpextension.service';
import {SessionService} from '../shared/services/session.service';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class CampaignService {

    campaignId = new BehaviorSubject<number>(null);
    campaignStartDate = new BehaviorSubject<Date>(null);
    campaigns: any[] = [];
    orders: any [] = [];

    constructor(private http: httpExtensionService,
                private config: ConfigService,
                private sessionService: SessionService) {
    }


    getCampaigns(): Observable<any> {
        const user_token: string = this.getToken();
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.apiURI + this.config.fundrasing_campaign, {
            headers: headers
        });
    }

    broadcastCampaignId(campaignId: number) {
        this.campaignId.next(campaignId);
    }

    broadcastCampaignStartDate(campaignStartDate: Date) {
        this.campaignStartDate.next(campaignStartDate);
    }

    isCampaignEnding(campaignStartDate: Date): Boolean {
        if (this.campaignStartDate === null) {
            return false;
        }

        const endDate = new Date(campaignStartDate.getTime() + 1209600000);
        return new Date().getTime() > endDate.getTime();
    }

    listCampaigns(userData) {
        const body = userData;
        const user_token: string = this.sessionService.getToken();
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.apiURI + this.config.fundrasing_campaign + '/list', body, {
            headers: headers
        });
    }


    saveCampaigns(data: any): Observable<any> {
        const user_token: string = this.getToken();
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.apiURI + this.config.fundrasing_campaign, data, {
            headers: headers
        });
    }


    private getToken() {
        let user_token;
        if (this.sessionService.checkSessionCookie() !== undefined) {
            user_token = this.sessionService.checkSessionCookie();
        } else if (this.sessionService.checkStorageSession() != null) {
            user_token = this.sessionService.checkStorageSession();
        }

        return user_token;
    }


    getOrders(id) {
        const user_token: string = this.getToken();
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.apiURI + this.config.fundrasing_order_campaign + `/${id}`, {
            headers: headers
        });
    }


    getCampaign(id): Observable<any> {
        const user_token: string = this.getToken();
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.apiURI + this.config.fundrasing_campaign + `/${id}`, {
            headers: headers
        });
    }


    deleteCampaign(id): Observable<any> {
        const user_token: string = this.getToken();
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.delete(this.config.apiURI + this.config.fundrasing_campaign + `/${id}`, {
            headers: headers
        });
    }


    getOrder(id): Observable<any> {
        const user_token: string = this.getToken();
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.apiURI + this.config.fundrasing_order + `/${id}`, {
            headers: headers
        });
    }

    determineRegionFromZip(zip: string) {
        const zipSantaBarbaraCounty = ['93013', '93014', '93067', '93101', '93102', '93103', '93105', '93106', '93107', '93108', '93109', '93110', '93111', '93116', '93117', '93118', '93120', '93121', '93130', '93140', '93150', '93160', '93190', '93199', '93254', '93427', '93429', '93434', '93436', '93437', '93438', '93440', '93441', '93454', '93455', '93456', '93457', '93458', '93460', '93463', '93464'];
        const zipVenturaCounty = ['91319', '91320', '91358', '91359', '91360', '91361', '91362', '91377', '93001', '93002', '93003', '93004', '93005', '93006', '93007', '93009', '93010', '93011', '93012', '93015', '93016', '93020', '93021', '93022', '93023', '93024', '93030', '93031', '93032', '93033', '93034', '93035', '93036', '93040', '93041', '93042', '93043', '93044', '93060', '93061', '93062', '93063', '93064', '93065', '93066', '93094', '93099'];

        if (zipSantaBarbaraCounty.includes(zip)) {
            return 'SANTABARBARA';
        } else if (zipVenturaCounty.includes(zip)) {
            return 'VENTURA';
        } else {
            return '';
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/campaign/campaign.service.ts